import { findSuggestedSession } from './logic'
import type { AppState, CoursePeriod } from './types'

export type MasterView = 'home' | 'course' | 'live' | 'review' | 'matrix' | 'periods' | 'audit' | 'import' | 'settings' | 'new-period' | 'period-settings' | 'students'
export interface MasterNavigation { view: MasterView; periodId: string; sessionId: string }

export const activeSession = (state: AppState) => state.sessions.find((session) => session.status === 'ACTIVE')
export const pendingReviews = (state: AppState, periodId?: string) => state.sessions.filter((session) => session.status === 'REVIEW' && (!periodId || session.periodId === periodId))

export function initialMasterNavigation(state: AppState): MasterNavigation {
  const active = activeSession(state)
  return active
    ? { view: 'live', periodId: active.periodId, sessionId: active.id }
    : { view: 'home', periodId: state.periods.find((period) => period.status === 'ACTIVE')?.id || state.periods[0]?.id || '', sessionId: '' }
}

// Bootstrap/polling may recover ACTIVE, never redirect to a pending REVIEW.
export function recoverActiveNavigation(state: AppState, navigation: MasterNavigation): MasterNavigation {
  const active = activeSession(state)
  if (active && (navigation.sessionId !== active.id || !['live', 'settings'].includes(navigation.view))) {
    return { view: 'live', periodId: active.periodId, sessionId: active.id }
  }
  return navigation
}

export function periodNavigation(state: AppState, period: CoursePeriod): MasterNavigation {
  return recoverActiveNavigation(state, { view: 'course', periodId: period.id, sessionId: findSuggestedSession(state, period.id)?.id || '' })
}

export function canStartSession(state: AppState, sessionId: string, displayId: string): boolean {
  const session = state.sessions.find((item) => item.id === sessionId)
  const period = state.periods.find((item) => item.id === session?.periodId)
  const display = state.displays.find((item) => item.displayId === displayId)
  return !activeSession(state) && session?.status === 'DRAFT' && Boolean(period && period.status !== 'ARCHIVED') && display?.state === 'LINKED'
}
